import { render, staticRenderFns } from "./CronogramasList.vue?vue&type=template&id=9b97008e"
import script from "./CronogramasList.vue?vue&type=script&lang=js"
export * from "./CronogramasList.vue?vue&type=script&lang=js"
import style0 from "./CronogramasList.vue?vue&type=style&index=0&id=9b97008e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports